module.exports = "<div style=\"text-align:center\">\r\n\r\n    <img src=\"/app/content/images/404.png\" height=\"543\" width=\"727\"/>\r\n</div>\r\n"